// Copyright 2017-2026 @polkadot/react-components authors & contributors
// SPDX-License-Identifier: Apache-2.0

const languageCache: Record<string, Record<string, string>> = {};

export default languageCache;
